export enum ReferenceDataSourceTypes {
    SERVICE_CONFIGURATION = "service-configuration",
    REPORTS = "reports",
    AXNADMIN_CORE = "axnadmin-core",
    IDP_CONFIGURATION = "idp-configuration",
    ALERTS = "alert",
    MANAGEMENT_CONSOLE = "management-console",
    ORGANIZATION_DETAILS = "orgnaization-details"
}